import { render } from "./DashboardCentrosActivacion.vue?vue&type=template&id=40b6fd30&scoped=true"
import script from "./DashboardCentrosActivacion.vue?vue&type=script&lang=js"
export * from "./DashboardCentrosActivacion.vue?vue&type=script&lang=js"

import "./DashboardCentrosActivacion.vue?vue&type=style&index=0&id=40b6fd30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b6fd30"]])

export default __exports__